"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWidgetAlert = exports.isWidgetAlertDefinition = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var objRef_1 = require("../objRef");
var filterContext_1 = require("./filterContext");
/**
 * Type-guard testing whether the provided object is an instance of {@link IWidgetAlertDefinition}.
 * @alpha
 */
function isWidgetAlertDefinition(obj) {
    return (hasWidgetAlertBaseProps(obj) &&
        (!objRef_1.isObjRef(obj.ref) ||
            filterContext_1.isFilterContextDefinition(obj.filterContext)));
}
exports.isWidgetAlertDefinition = isWidgetAlertDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IWidgetAlert}.
 * @alpha
 */
function isWidgetAlert(obj) {
    return hasWidgetAlertBaseProps(obj) && !isWidgetAlertDefinition(obj);
}
exports.isWidgetAlert = isWidgetAlert;
/**
 * @internal
 */
function hasWidgetAlertBaseProps(obj) {
    return (!isEmpty_1.default(obj) &&
        (obj.whenTriggered === "underThreshold" ||
            obj.whenTriggered === "aboveThreshold"));
}
//# sourceMappingURL=alert.js.map